import React, { useState, useEffect, useRef } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import _ from 'lodash';
//components
import ToastElement from '../../../Components/UiComponents/ToastElement';
import TabMenuElement from '../../../Components/UiComponents/TabMenuElement';
import Address from './Address';
import Contacts from './Contacts';
import Loader from '../../../Components/UiComponents/Loader';
// Services
import { getField } from '../../../Services/tooltipService';
import { getCustomerDetails } from '../../../Services/clientService';
import { getModulePermissions } from '../../../Services/pricingPlanService';
import PlaylistVideos from '../../../Components/Videos/PlaylistVideos';
import { Dialog } from 'primereact/dialog';
import ButtonElement from '../../../Components/UiComponents/ButtonElement';

export default function AddressBook(props) {
    const { clientId, version } = useParams();
    const [customerId, setCustomerId] = useState(null);
    const toastRef = useRef();
    const [items, setItems] = useState();
    const [activeIndex, setActiveIndex] = useState(0);
    const [branch, setBranch] = useState(null);
    const [customerDetails, setCustomerDetails] = useState({});
    const [loading, setLoading] = useState(false);
    const [pricingPlan, setPricingPlan] = useState('');
    const [tabPermissions, setTabPermissions] = useState({});
    const [addressBook, setAddressBook] = useState([]);
    const [commonFields, setCommonFields] = useState();
    const [havingBranch, setHavingBranch] = useState(null);
    const [showVideo, setShowVideo] = useState(false);
    const navigate = useNavigate()
    useEffect(() => {
        // Fetching end user data from local storage
        const enduserStr = localStorage.getItem("enduser");

        // Checking if end user data exists in local storage
        if (enduserStr) {
            // Parsing end user data
            const enduser = JSON.parse(enduserStr);

            // Extracting customer information from end user data
            const customer = enduser.customer;

            // Setting customer ID state
            setCustomerId(customer);
            const branch = enduser.branch;
            // Setting customer ID state
            setBranch(branch);
        } else {
            // Logging if no end user data found in local storage
            navigate("/login")
            localStorage.clear()
        }

    }, []);

    useEffect(() => {
        if (customerId) {
            getFieldData();
            getCustomerDetail();
        }
    }, [customerId]);

    useEffect(() => {
        if (customerDetails) {
            getModulePermission()
        }
    }, [customerDetails])

    const getModulePermission = async () => {
        try {
            if (pricingPlan) {
                const res = await getModulePermissions(pricingPlan, "Address Book");
                if (res && res.data) {
                    const modulePermissions = res.data;
                    if (modulePermissions.status) {
                        var tabPermissions = {};
                        _.filter(modulePermissions.sub_modules, (sub_module) => {
                            tabPermissions[sub_module.module_name] = sub_module.status;
                        });
                        setTabPermissions(tabPermissions);
                    }
                }
            } 
            // else {
            //     toastRef.current.showToast({
            //         type: 'error',
            //         message: 'Pricing Plan Data is not fetched'
            //     });
            //     return;
            // }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const getCustomerDetail = async () => {
        try {
            if (customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            const response = await getCustomerDetails(customerId);
            if (response && response.data) {
                setHavingBranch(response?.data?.havingBranch)
                setCustomerDetails(response)
                setPricingPlan(response.data.pricing_plan)
            }

        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    useEffect(() => {
        const tabs = [
            {
                label: _.find(addressBook.sub_modules, { sub_module_name: "Address" })?.display_name,
                icon: 'pi pi-address-book',
                Component: <Address
                    customerId={customerId}
                    clientId={clientId}
                    addressBookData={{
                        "commonFields": commonFields,
                    }} />
            },
            {
                label: _.find(addressBook.sub_modules, { sub_module_name: "Contacts" })?.display_name,
                icon: 'pi pi-phone',
                Component: <Contacts
                    customerId={customerId}
                    clientId={clientId}
                    clientSectionsSummary={addressBook}
                    havingBranch={havingBranch}
                    branch={branch}
                />
            },
        ]
        var newItems = []
        if (tabPermissions['Address']) {
            newItems.push(tabs[0])
        }
        if (tabPermissions['Contacts']) {
            newItems.push(tabs[1])
        }
        setItems(newItems);
        setTimeout(() => { setLoading(false) }, 1000)
    }, [customerDetails, tabPermissions]);

    const getFieldData = async () => {
        try {
            if (customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            setLoading(true)
            const response = await getField(customerId);
            if (response && response.data) {
                const clientModuleData = response.data;
                if (clientModuleData) {
                    var AddressBook = _.find(clientModuleData.cust[0].modules, { module_name: "Address Book", status: true });
                    setAddressBook(AddressBook)
                    var commonModules = _.find(clientModuleData.cust[0].modules, { module_name: "Common Fields", status: true });
                    setCommonFields(_.find(commonModules.sub_modules, { sub_module_name: "Common Fields" }).fields);
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false)
        }
    };

    const updates = (e) => {
        setActiveIndex(e.index)
    }

    const handleButtonClick = () => {
        setShowVideo(true);
    };

    const closeVideo = () => {
        setShowVideo(false);
    };

    // For now, we will assume the content is part of the React component
    return (
        <div className="group-table-component stakeholder">
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="col-md-12 mt-2 text-right">
                    <ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
            </div>
            <div>
                <TabMenuElement items={items} activeIndex={activeIndex} onTabChange={(e) => updates(e)} />
            </div>
            <div>
                {items && <div className='mt-10'>
                    {items[activeIndex] && items[activeIndex].Component}
                </div>}
            </div>
            <Dialog id="videoModal" visible={showVideo}
                breakpoints={{
                    '1200px': '80vw',    // Larger modal on bigger screens
                    '1024px': '85vw',    // Slightly smaller for medium screens
                    '769': '90vw',     // Responsive on tablets
                    '641px': '95vw',     // Almost full-width on mobile
                }}
                modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
            >
                <div className="video-overlay">
                    <div className="video-container">
                        <PlaylistVideos playlistId={process.env.REACT_APP_MAIN_MODULES_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="address_book" />
                    </div>
                </div>
            </Dialog>
        </div>
    );
};